/**
 *
 * FBPreviewFile
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { saveAs } from 'file-saver';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// assets
import { Input, CloseOutlined, EyeOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';
import HiddenField from 'components/Forms/Fields/HiddenField';

// utils
import { slugify, truncateFilename } from 'utils/helpers/helper.general';

function FBPreviewFile({
  file,
  fileTitle,
  title,
  showTitle,
  icon,
  showIcon,
  iconPreview,
  showIconPreview,
  showInput,
  prevStep,
  remove,
  name,
  // default props
  className,
}) {
  const childClassNames = classNames('tcf-fb-preview-file', className);
  const { t } = useTranslation();

  const getFileName = (fileTitle) => {
    let fileName = fileTitle || '';
    if (!!!fileTitle) {
      if (!!file && typeof file === 'string') {
        fileName = truncateFilename(file, 10);
      } else if (!!file && typeof file === 'object') {
        fileName = file?.name;
      }
    }
    return fileName;
  }

  let fileName = getFileName(fileTitle);

  const openFileViewer = useCallback(() => {
    //  setOpen(!isOpen);
    file && saveAs(file, slugify(fileName));
  }, [file]);

  return (
    !!file && (
      <div className={childClassNames}>
        {showTitle && <h3 className="preview-title">{!!title && title || t("absences.proof")}</h3>}
        <div className="preview-file">
          <div className="file-backround" onClick={openFileViewer}>
            {showIcon && <CustomIcons className="file-icon" type={icon} />}
            <span className="file-name fp-file-name">{fileName}</span>
          </div>
          {showIconPreview && (
            <div className="file-view fp-preview-name" onClick={openFileViewer}>
              {iconPreview ? iconPreview : <EyeOutlined />}
            </div>
          )}
          {!!remove && (
            <CloseOutlined
              className="file-delete"
              onClick={() => {
                remove(file);
              }}
            />
          )}
        </div>
        {showInput && (
          <HiddenField data={{ name: name }} value={file} index={0} />
        )}
      </div>
    )
  );
}

FBPreviewFile.defaultProps = {
  name: 'preview-media',
  showTitle: true,
  showIcon: true,
  showIconPreview: true,
  canRemode: true,
  icon: 'proof-document',
  showInput: false,
  fileTitle: '',
  iconPreview: false,
};
FBPreviewFile.propTypes = {
  title: PropTypes.string,
  fileTitle: PropTypes.string,
  showTitle: PropTypes.bool,
  remove: PropTypes.func,
};

export default memo(FBPreviewFile);
